<template>
    <div class="c-appointment-item-sales">
        <button class="btn-round black" :disabled="limited" @click.prevent.stop="showEditSalesDropdown">
            {{formatSalesName}}
        </button>

        <div class="options" v-if="editPopup">
            <div v-for="sale in allSales" :key="sale.id"
                class="option" :class="{selected: sale.id == appointment.sales_id}"
                @click.prevent.stop="setSales(sale)">
                {{sale.firstname}} {{sale.lastname}}
            </div>
        </div>
    </div>
</template>

<script>
import {formatSalesName} from "@/utils/utils";
import DocumentClickMixin from "@/mixins/DocumentClickMixin";
import {apiStore} from "@/stores/api";

export default {
    name : "AppointmentItemSales",
    mixins: [DocumentClickMixin],
    props: {
        appointment: {type: Object, required: true}
    },

    data() {
        return {
            limited: true,
            allSales : null,
            editPopup : false
        };
    },

    created() {
        this.limited = apiStore().loggedInSales.limited;
    },

    computed: {
        formatSalesName() {
            const name = formatSalesName(this.appointment.sales);
            return name !== "" ? name : "??";
        }
    },

    methods: {
        async setSales(sale) {
            // eslint-disable-next-line vue/no-mutating-props
            this.appointment.sales_id = sale.id;
            // eslint-disable-next-line vue/no-mutating-props
            this.appointment.sales = sale;

            await apiStore().updateAppointment(this.appointment);

            this.editPopup = false;
        },

        async showEditSalesDropdown() {
            this.allSales = await apiStore().getSalesForShop();

            this.$nextTick(() => {
                this.editPopup = true;
            });
        },

        documentClickTriggered() { //called from mixin
            this.editPopup = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-appointment-item-sales {
        position: relative;

        &.active {
            position: absolute;
        }

        $borderColor : #efefef;
        $optionHeight : 2rem;
        .options {
            box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.15);
            position: fixed;
            width: 40%;
            left: 37%;
            z-index: 55;
            overflow-y:scroll;
            max-height : #{5 * $optionHeight};
            margin-top: 0.3rem;
        }

        .option {
            background : white;
            border-left : solid 1px $borderColor;
            border-right : solid 1px $borderColor;
            border-bottom : solid 1px $borderColor;
            height: $optionHeight;
            line-height: $optionHeight;
            padding-left : .5rem;
            color : black;

            &:first-child {
                border-top : solid 1px $borderColor;
            }

            &.selected {
                background : $borderColor;
                font-weight: bold;
            }
        }
    }
</style>
